// src/utils/uploadAccessCodes.js
import { db } from './firebaseConfig';
import { doc, setDoc } from 'firebase/firestore';

const accessCodes = [
  "essens001!", "kodeSti23*", "ionPort@7", "VisjonX12", "SkaperN3tt",
  "Kjerne2025#", "EttNavn99", "lysveien_21", "EssensK1ld3", "refleks!Kode",
  "AlfaZonen.1", "ionstorm23", "SannhetG4", "portalQX99", "kodeStjerne",
  "navnesteg10", "essForm01", "Grensel0s$", "Qgenesis88", "trinnkodeX",
  "EssensBrønn", "ionGlimt44", "AktivNote!3", "SkaperPass2", "Ess2025Verdi",
  "kodeStart33", "InngangONE", "essensDelta", "ZonenAdam!", "kodeEssX30"
];

export const uploadAccessCodes = async () => {
  try {
    for (const code of accessCodes) {
      const codeId = code.replace(/[.#$/[\]]/g, "-"); // 🛡️ fjerner ulovlige tegn for Firestore
      const codeRef = doc(db, "accessCodes", codeId);
      await setDoc(codeRef, {
        code,
        used: false,
        usedBy: null,
        timestampUsed: null,
      });
    }
    console.log("✅ 30 unike passord ble lastet opp (uten duplikater).");
  } catch (error) {
    console.error("❌ Feil under opplasting:", error);
  }
};
